import { capitalize, find } from "lodash";
import React, { useContext, useEffect, useState } from "react";
import { TouchableOpacity } from "react-native";
import BookmarkButton from "../../components/BookmarkButton";
import Resource from "../../components/Resource";
import { InlineRichText } from "../../components/RichText";
import { FurnitureContext } from "../../utils/furniture";
import { useExternalState } from "../../utils/me";
import { useResourceCategories } from "../../utils/contentful";
import { NavContext } from "../../utils/nav";
import { Caption, Container, Header, Resources, Scroll, Title } from "./styles";

const ResourceCategory = ({ navigation, route }) => {
    const [isBookmarked, setIsBookmarked] = useState(false);
    const {
        bookmarkStates,
        api: { bookmarkContent, unBookmarkContent },
    } = useExternalState();
    const { setLeafNav } = useContext(NavContext);
    const {
        strings: { resourceLabel, resourcesLabel },
    } = useContext(FurnitureContext);
    const { resourceCategoryId } = route.params;
    const { data: resourceCategory } = route.params;
    useEffect(() => {
        setLeafNav(navigation);
    }, [navigation]);

    useEffect(() => {
        if (!resourceCategory) {
            navigation.goBack();
        }
    }, []);

    useEffect(() => {
        if (bookmarkStates) {
            const isBookmarked = !!bookmarkStates.find(
                bookmark => bookmark.contentId === resourceCategoryId,
            );
            setIsBookmarked(isBookmarked);
        }
    }, [bookmarkStates]);

    const count = resourceCategory.resources.length;
    const suffix =
        count > 1 ? capitalize(resourcesLabel) : capitalize(resourceLabel);

    const handlePressBookmark = async () => {
        if (isBookmarked) {
            unBookmarkContent(resourceCategoryId);
        } else {
            bookmarkContent(resourceCategoryId);
        }
        setIsBookmarked(!isBookmarked);
    };

    const categoryTitle = resourceCategory.category ? (
        <InlineRichText doc={resourceCategory.category} />
    ) : (
        resourceCategory.title
    );

    return (
        <Container>
            <BookmarkButton
                isBookmarked={isBookmarked}
                onPress={handlePressBookmark}
            />
            <Scroll showsVerticalScrollIndicator={false}>
                <TouchableOpacity onPress={() => navigation.goBack()}>
                    <Header>
                        <Title type="h3">{categoryTitle}</Title>
                        <Caption>{`${count} ${suffix}`}</Caption>
                    </Header>
                </TouchableOpacity>
                <Resources>
                    {resourceCategory.resources.map(
                        (resource, index, parent) => (
                            <Resource
                                key={resource._id}
                                resource={resource}
                                hasDivider={index < parent.length - 1}
                            />
                        ),
                    )}
                </Resources>
            </Scroll>
        </Container>
    );
};

export default ResourceCategory;
